// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconHardwareUsbError_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 24C21.6495 24 24 21.6495 24 18.75C24 15.8505 21.6495 13.5 18.75 13.5C15.8505 13.5 13.5 15.8505 13.5 18.75C13.5 21.6495 15.8505 24 18.75 24ZM16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" class="svg-fg"/>
  <path d="M9 4H11V6H9V4ZM12 4H14V6H12V4Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4 8V21L7 24H13.75C13.148 23.4265 12.6445 22.7505 12.2675 22H8L6 20L6 10L16.8571 10.0714V11.7496C17.4606 11.5868 18.0951 11.5 18.75 11.5C18.8337 11.5 18.917 11.5014 19 11.5042V8H18L17.9286 0H5.07143V8H4ZM7 8V2L16 2V8H7Z" class="svg-bg"/>
</svg>
`;
/**
 * IconHardwareUsbError is a generated icon component.
 */
let IconHardwareUsbError = IconHardwareUsbError_1 = class IconHardwareUsbError extends IconBaseElement {
    render() {
        return html `${IconHardwareUsbError_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconHardwareUsbError.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconHardwareUsbError = IconHardwareUsbError_1 = __decorate([
    customElement('zui-icon-hardware-usb-error')
], IconHardwareUsbError);
export { IconHardwareUsbError };
